import logo from "../../assets/images/logoUni.png";
import {
  Facebook,
  Instagram,
  Linkedin,
  Menu,
  Twitter,
  Youtube
} from "lucide-react";
import { SpotifyIcon } from "../svg/spotify";
import { useState } from "react";
import clsx from "clsx";

const navItems = [
  "ARTISTS & WRITERS",
  "NEWS",
  "FILM, TV + MEDIA",
  "SONGS",
  "ABOUT",
  "CONTACT"
];
export default function HeaderBrand({ onOpen }: { onOpen?: () => void }) {
  const [active, setActive] = useState("FILM, TV + MEDIA");
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="max-w-6xl w-full flex justify-between items-center py-4 relative">
      {/* Logo + Text */}
      <div className="flex items-center gap-2">
        <img src={logo} alt="UMPG Logo" className="h-[50px] sm:h-[70px]" />
      </div>
      {/* Mobile toggle button */}
      <div className="flex justify-end sm:hidden">
        <button
          onClick={() => {
            setIsOpen(!isOpen);
            onOpen && onOpen();
          }}
          className="text-gray-800"
        >
          <Menu />
        </button>
      </div>

      {/* Social Icons - only on desktop */}
      <div className="hidden sm:flex gap-1" onClick={onOpen}>
        <CircleIcon icon={<Twitter size={14} />} />
        <CircleIcon icon={<Instagram size={14} />} />
        <CircleIcon icon={<Facebook size={14} />} />
        <CircleIcon icon={<SpotifyIcon />} />
        <CircleIcon icon={<Youtube size={14} />} />
        <CircleIcon icon={<Linkedin size={14} />} />
      </div>

      {/* Mobile nav list */}
      {isOpen && (
        <ul className="absolute top-full left-0 z-50 w-full bg-white shadow-md sm:hidden text-sm font-semibold border-t border-gray-300">
          {navItems.map((item) => (
            <li
              key={item}
              onClick={() => {
                setActive(item);
                setIsOpen(false);
              }}
              className={clsx(
                "px-4 py-2 border-b border-gray-200",
                active === item ? "bg-[#0071bb] text-white" : "text-gray-800"
              )}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function CircleIcon({ icon }: { icon: React.ReactNode }) {
  return (
    <div className="w-6 h-6 rounded-full border border-gray-300 flex items-center justify-center text-gray-600 hover:bg-gray-100 cursor-pointer">
      {icon}
    </div>
  );
}
